import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import BlacklistDetail from "./Blacklist";



const HEADER_HEIGHT = 56;

const Blacklist = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [nomeBlacklist, setNomeBlacklist] = useState("");
  const [blacklists, setBlacklists] = useState([]);
  const [contactsByList, setContactsByList] = useState({});
  const [openListMenuId, setOpenListMenuId] = useState(null);
  const [editListModalOpen, setEditListModalOpen] = useState(false);
  const [editingList, setEditingList] = useState(null);
  const [editedListName, setEditedListName] = useState('');
  const navigate = useNavigate();
  const params = useParams();
  const paramId = params?.id;

  useEffect(() => {
    const onAdd = (e) => {
      const entry = e?.detail;
      const listId = entry?.listId;
      if (entry && listId) {
        setContactsByList(prev => ({
          ...prev,
          [listId]: [entry, ...(prev[listId] || [])]
        }));
      }
    };

    const onEdit = (e) => {
      const entry = e?.detail;
      const listId = entry?.listId;
      if (entry && listId) {
        setContactsByList(prev => ({
          ...prev,
          [listId]: (prev[listId] || []).map(c => c.id === entry.id ? { ...c, ...entry } : c)
        }));
      }
    };

    const onDelete = (e) => {
      const payload = e?.detail;
      const listId = payload?.listId;
      const id = payload?.id;
      if (listId && id) {
        setContactsByList(prev => ({
          ...prev,
          [listId]: (prev[listId] || []).filter(c => c.id !== id)
        }));
      }
    };

    window.addEventListener('blacklist:add', onAdd);
    window.addEventListener('blacklist:edit', onEdit);
    window.addEventListener('blacklist:delete', onDelete);
    return () => {
      window.removeEventListener('blacklist:add', onAdd);
      window.removeEventListener('blacklist:edit', onEdit);
      window.removeEventListener('blacklist:delete', onDelete);
    };
  }, []);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
                ? 220
                : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
                ? 220
                : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
                ? 220
                : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (
            <a href="/app">
              <img src={LogoCompleta} alt="Logo Completa" style={{ height: 40, transition: "all 0.3s" }} />
            </a>
          ) : (
            <a href="/app">
              <img src={LogoIcone} alt="Logo Ícone" style={{ height: 32, width: 32, transition: "all 0.3s" }} />
            </a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}>
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12, color: "#fff" }}>Dashboard</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Campanha" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Campanhas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Adicionarauto" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi-robot" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Contas" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Operacoes" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-gear" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>

          <li className="w-100">
            <a
              href="/Blacklist"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-person-x" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Blacklist</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
          </li>



          <li className="w-100">
            <a
              href="/Webhook"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-link-45deg" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Webhook</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
          </li>

          <li className="w-100">
            <a href="/broadcast" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-wifi" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Broadcasts</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>

        </ul>
      </nav>
      {/* Header fixo no topo, mas atrás do menu lateral */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: HEADER_HEIGHT,
          background: "#005c53",
          zIndex: 1200,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
          <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Blacklist</span>
        </div>
        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a
              href="#"
              className="nav-link d-flex align-items-center p-0"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#fff", cursor: "pointer" }}
            >
              <i
                className="bi bi-person-circle"
                style={{
                  fontSize: 28,
                }}
              ></i>
              <span
                className="d-none d-lg-inline ms-2"
                style={{
                  padding: "3px 5px",
                  borderRadius: 16,
                  transition: "background 0.2s",
                  display: "inline-block",
                }}
              >
                Nome do Usuário
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li>
                <a className="dropdown-item" href="/Editarperfil">Perfil</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Treinamentos</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Termos de uso</a>
              </li>

              <li>
                <a className="dropdown-item" href="/sign-in">Sair</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Conteúdo da página de campanha */}
      <div style={{
        marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : (sidebarOpen ? 0 : 56),
        paddingTop: HEADER_HEIGHT,
        width: window.innerWidth > 768
          ? sidebarOpen
            ? "calc(100% - 220px)"
            : "calc(100% - 70px)"
          : (sidebarOpen ? "100vw" : "calc(100vw - 56px)"),
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
        position: "relative",
      }}>
        {!paramId && (
          <div style={{ position: "absolute", top: 80, right: 16, zIndex: 1400 }}>
            <button
              className="btn"
              style={{
                background: "#51a197",
                color: "#fff",
                borderRadius: 8,
                padding: "8px 16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                border: "none",
                fontWeight: 700,
              }}
              onClick={() => setModalAberto(true)}
            >
              CADASTRAR
            </button>
          </div>
        )}

        {editListModalOpen && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.35)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ background: '#fff', borderRadius: 12, padding: 28, minWidth: 340, boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
              <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 12, color: '#005c53' }}>Editar Blacklist</div>
              <input
                type="text"
                placeholder="Nome da Blacklist"
                value={editedListName}
                onChange={e => setEditedListName(e.target.value)}
                style={{
                  width: '100%',
                  padding: 12,
                  fontSize: 16,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  outline: 'none',
                  background: 'white',
                  marginBottom: 16,
                  color: '#222',
                }}
              />
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button onClick={() => { setEditListModalOpen(false); setEditingList(null); setEditedListName(''); }} style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#ccc', color: '#222', fontWeight: 500, cursor: 'pointer' }}>Cancelar</button>
                <button
                  onClick={() => {
                    if (!editingList) return;
                    if (editedListName.trim()) {
                      setBlacklists(prev => prev.map(b => b.id === editingList.id ? { ...b, nome: editedListName.trim() } : b));
                      // if viewing this list, update state in URL so detail shows updated name
                      if (String(paramId) === String(editingList.id)) {
                        navigate(`/blacklist/${editingList.id}`, { replace: true, state: { nome: editedListName.trim() } });
                      }
                      setEditListModalOpen(false);
                      setEditingList(null);
                      setEditedListName('');
                    }
                  }}
                  style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#005c53', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
                  disabled={!editedListName.trim()}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        )}

        {modalAberto && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.35)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ background: '#fff', borderRadius: 12, padding: 28, minWidth: 340, boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
              <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 12, color: '#005c53' }}>Cadastrar Blacklist</div>
              <input
                type="text"
                placeholder="Nome da Blacklist"
                value={nomeBlacklist}
                onChange={e => setNomeBlacklist(e.target.value)}
                style={{
                  width: '100%',
                  padding: 12,
                  fontSize: 16,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  outline: 'none',
                  background: 'white',
                  marginBottom: 16,
                  color: '#222',
                }}
              />
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button onClick={() => { setModalAberto(false); setNomeBlacklist(''); }} style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#ccc', color: '#222', fontWeight: 500, cursor: 'pointer' }}>Cancelar</button>
                <button
                  onClick={() => {
                    if (nomeBlacklist.trim()) {
                      const novo = { id: Date.now(), nome: nomeBlacklist.trim() };
                      setBlacklists(prev => [novo, ...prev]);
                      console.log('Cadastrar Blacklist:', novo);
                      setModalAberto(false);
                      setNomeBlacklist('');
                      // aqui você pode disparar chamada ao backend para salvar a blacklist
                    }
                  }}
                  style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#005c53', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
                  disabled={!nomeBlacklist.trim()}
                >
                  Cadastrar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Lista de Blacklists criadas ou detalhe */}
        {paramId ? (
          <div style={{ padding: 20, marginTop: window.innerWidth <= 768 ? 120 : 80, minHeight: 'calc(100vh - 140px)' }}>
            <BlacklistDetail contacts={contactsByList[paramId] || []} />
          </div>
        ) : (
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            padding: 20,
            marginTop: window.innerWidth <= 768 ? 120 : 80,
            transition: 'margin-top 0.2s',
          }}>
            {blacklists.length === 0 ? (
              <div style={{ color: '#666', fontStyle: 'italic' }}>Nenhuma blacklist criada ainda.</div>
            ) : (
              blacklists.map(item => (
                <div key={item.id} style={{ position: 'relative' }}>
                  <div onClick={() => navigate(`/blacklist/${item.id}`, { state: { nome: item.nome } })} style={{
                    minWidth: 220,
                    maxWidth: 320,
                    background: '#fff',
                    borderRadius: 12,
                    padding: 16,
                    boxShadow: '0 4px 18px rgba(0,0,0,0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    cursor: 'pointer'
                  }}>
                    <div style={{
                      width: 48,
                      height: 48,
                      borderRadius: 8,
                      background: '#ffebee',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#c0392b',
                      fontSize: 22,
                    }}>
                      <i className="bi bi-person-x" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ fontWeight: 700, color: '#222' }}>{item.nome}</div>
                      <div style={{ fontSize: 13, color: '#666' }}>Blacklist</div>
                    </div>
                  </div>

                  <div style={{ position: 'absolute', top: 8, right: 8 }}>
                    <button onClick={(e) => { e.stopPropagation(); setOpenListMenuId(openListMenuId === item.id ? null : item.id); }} className="btn btn-sm" style={{ padding: '6px 8px', border: 'none', background: 'transparent' }}>⋯</button>
                    {openListMenuId === item.id && (
                      <div style={{ position: 'absolute', right: 0, top: 28, background: '#fff', border: '1px solid rgba(0,0,0,0.08)', boxShadow: '0 8px 24px rgba(0,0,0,0.08)', borderRadius: 8, zIndex: 1400 }}>
                        <div onClick={() => { setEditingList(item); setEditedListName(item.nome); setEditListModalOpen(true); setOpenListMenuId(null); }} style={{ padding: '8px 12px', cursor: 'pointer' }}>Editar</div>
                        <div onClick={() => {
                          setOpenListMenuId(null);
                          if (window.confirm('Confirmar exclusão desta blacklist?')) {
                            // remove blacklist and its contacts
                            setBlacklists(prev => prev.filter(b => b.id !== item.id));
                            setContactsByList(prev => {
                              const copy = { ...prev };
                              delete copy[item.id];
                              return copy;
                            });
                            if (String(paramId) === String(item.id)) {
                              navigate('/blacklist');
                            }
                          }
                        }} style={{ padding: '8px 12px', cursor: 'pointer' }}>Excluir</div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Blacklist;